import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=d3134bca&scoped=true&"
import script from "./summary.vue?vue&type=script&lang=ts&"
export * from "./summary.vue?vue&type=script&lang=ts&"
import style0 from "./summary.vue?vue&type=style&index=0&id=d3134bca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3134bca",
  null
  
)

export default component.exports